/**
 * توابعِ نرمیِ صحنه — پورتِ یک‌به‌یکِ Ease.cs یونیتی.
 *
 * ورودی x در [۰..۱]؛ خروجی معمولاً [۰..۱]، جز آن‌ها که عمداً فراتر می‌روند
 * (OutBack و OutBackSoft برای «رد شدن از هدف و نشستن»). هر انیمیشنی که این‌جا
 * می‌نویسیم باید از همین‌ها بگذرد، وگرنه با یونیتی یکی نمی‌شود — cubic-bezierِ
 * CSS نمی‌تواند این منحنی‌ها را دقیق بسازد.
 */
const clamp01 = (x: number) => (x < 0 ? 0 : x > 1 ? 1 : x);

export const linear = (x: number) => clamp01(x);

export function outCubic(x: number): number { x = clamp01(x); return 1 - Math.pow(1 - x, 3); }
export function inCubic(x: number): number { x = clamp01(x); return x * x * x; }
export function inOutCubic(x: number): number {
  x = clamp01(x);
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}

export function outBack(x: number): number {
  x = clamp01(x);
  const c1 = 1.70158, c3 = c1 + 1;
  return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
}

/** OutBack با overshootِ ملایم (~۵٪) — فرودِ کارت: کمی از هدف رد می‌شود و می‌نشیند. */
export function outBackSoft(x: number): number {
  x = clamp01(x);
  const c1 = 0.9, c3 = c1 + 1;
  return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
}

/** پیش‌آمادگی: اول کمی زیرِ صفر، بعد به ۱. */
export function inBack(x: number): number {
  x = clamp01(x);
  const c1 = 1.70158, c3 = c1 + 1;
  return c3 * x * x * x - c1 * x * x;
}

/** کِش‌سانی — پاپ‌آپِ فنری. */
export function outElastic(x: number): number {
  x = clamp01(x);
  if (x <= 0) return 0;
  if (x >= 1) return 1;
  const c4 = (2 * Math.PI) / 3;
  return Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
}

/** جهش — فرودِ سکه/جایزه. */
export function outBounce(x: number): number {
  x = clamp01(x);
  const n1 = 7.5625, d1 = 2.75;
  if (x < 1 / d1) return n1 * x * x;
  if (x < 2 / d1) { x -= 1.5 / d1; return n1 * x * x + 0.75; }
  if (x < 2.5 / d1) { x -= 2.25 / d1; return n1 * x * x + 0.9375; }
  x -= 2.625 / d1; return n1 * x * x + 0.984375;
}

/** LerpUnclamped یونیتی — با easingِ overshoot‌دار باید از هدف رد شود. */
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
